import {} from "openchat-client";
import { readable, writable } from "svelte/store";
const { subscribe, update } = writable(undefined);
export const toastStore = {
    subscribe,
    showFailureToast: (resourceKey, err) => {
        return update(() => ({
            kind: "failure",
            resourceKey: "subscribe" in resourceKey ? resourceKey : readable(resourceKey),
            err,
        }));
    },
    showSuccessToast: (resourceKey) => {
        window.setTimeout(() => update(() => undefined), 2500);
        return update(() => ({
            kind: "success",
            resourceKey: readable(resourceKey),
        }));
    },
    hideToast: () => update(() => undefined),
};
